module.exports = {
  context: {
    signupHeading: 'Join our mailing list',
    contactHeading: 'Contact',
    socialHeading: 'Connect',
    address: '12345 Address San Diego,\nCA 92104\n<a href="tel: +1 858-555-6789">858-555-6789</a>',
    login: {
      button: {
        text: 'Team Login',
        url: 'https://google.com',
        class: 'info'
      }
    },
    signup: '@form-signup',
    copyrightTitle: 'Adjoin, Inc.',
    socials: {
      facebook: 'http://www.facebook.com/',
      linkedin: 'http://www.linkedin.com/',
      twitter: 'http://www.twitter.com/',
      instagram: 'http://www.instagram.com/',
      youtube: 'http://www.youtube.com/'
    },
    footerNav: '@footer-navigation'
  }
}
